// extracted by mini-css-extract-plugin
export default {"nav__link":"NavList_nav__link__HJTdF","nav__list":"NavList_nav__list__+5VQC","nav__item":"NavList_nav__item__NAe0U","nav__activeLink":"NavList_nav__activeLink__DRfPs"};